import React from "react";
const { version } = require('../../../package.json');

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © 2021 - v{version}
        </p>
      </div>
    </div>
  );
};

export default Footer;
